import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TruncatedEllipsis from '../../shared/truncated-ellipsis';
import { recordStatisticsEvent } from '../../../services/statistics-service';
import dt from '../../../shared/theme';

const Header = styled.div`
  margin: 0;

  & > h2 {
    margin: 0px;
    font-size: 19px;
    line-height: 130%;

    ${props => dt(props).theme.isLarge && `
      font-size: 24px;
    `};

    > button {
      color: ${props => dt(props).theme.bodyColor};
      font-family: ${props => dt(props).theme.fontFamilyHeader};
      font-weight: ${props => dt(props).theme.fontWeightBold};
      text-align: left;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export default function WireTitle({ wire, onHeaderWire, position }) {
  const wireUrl = `/wires/${wire.slug}`;

  const handleClick = () => {
    if (onHeaderWire) { return false; }
    recordStatisticsEvent({
      event: 'link_click',
      statisticable: 'wire',
      id: wire.id,
      clicked_url: `/wires/${wire.slug}`,
      page: window.location.pathname,
      custom_data: {
        section: 'all_wires',
        page: 'series',
        position,
      },
    });

    return false;
  };

  const wireClicked = e => {
    e && e.preventDefault();
    handleClick();
    window.location = wireUrl;
  };

  return (
    <Header>
      <h2>
        <button type="button" onClick={wireClicked}>
          <TruncatedEllipsis
            lines={4}
            summary={wire.title}
            useReadMore={false}
            hasTags={false}
          />
        </button>
      </h2>
    </Header>
  );
}

WireTitle.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  onHeaderWire: PropTypes.bool,
  position: PropTypes.number,
};

WireTitle.defaultProps = {
  onHeaderWire: false,
  position: null,
};
